<ul>
  <li (click)="file.click()">
    <input
      #file
      type="file"
      accept=".doc,.docx,.pdf,.txt,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      (change)="sendFile($event, 'file')"
    />
    <i class="material-icons"> insert_drive_file </i>
    <span> File </span>
  </li>
  <li (click)="image.click()">
    <input
      #image
      type="file"
      accept="image/*"
      (change)="sendFile($event, 'image')"
    />
    <i class="material-icons"> image </i>
    <span> Image </span>
  </li>
  <li (click)="video.click()">
    <input
      #video
      type="file"
      accept="video/*"
      (change)="sendFile($event, 'video')"
    />
    <i class="material-icons"> local_movies </i>
    <span> Video </span>
  </li>
  <li (click)="audio.click()">
    <input
      #audio
      type="file"
      accept="audio/*"
      (change)="sendFile($event, 'audio')"
    />
    <i class="material-icons"> music_note </i>
    <span> Audio </span>
  </li>
  <li
    *ngIf="scenarios && scenarios.length"
    brnPopup
    [component]="scenariosPopupComponent"
    [appendClass]="'media-popup'"
    [position]="'right'"
  >
    <i class="material-icons">archive</i>
    <span>Scenario</span>
    <!-- <div class="crm-chat__input-bubble--inner">
      <ul>
        <li ng-repeat="scenario in scenarios">
          <span ng-click="runScenario(scenario.scenario_id)"
            >{{scenario.name}}</span
          >
          <i
            ng-hide="!checkScenarioStatus(value.scenario_id)"
            class="material-icons status"
            >done</i
          >
        </li>
      </ul>
    </div> -->
  </li>
</ul>
